import React from 'react';
import { Box, Flex, Image, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { openChat } from 'helpers/supportChat';
import UserMenu from 'components/molecules/UserMenu';
import Slash from '../../../assets/icon-slash.svg';
import { ClaimHeader } from '../components/claimHeader';

export const Mismatch = ({ activeNetwork, company }) => (
  <>
    <Box sx={{ position: 'absolute', top: '24px', right: '24px' }}>
      <UserMenu onlyLogout />
    </Box>
    <Flex flexDirection="column" sx={{ gap: '80px', maxWidth: '360px', mx: 'auto', mt: '200px', pb: '80px' }}>
      <ClaimHeader activeNetwork={activeNetwork} company={company} />
      <Flex flexDirection="column" sx={{ gap: '16px', alignItems: 'center' }}>
        <Image src={Slash} width="80px" height="80px" />
        <Text sx={{ fontSize: '18px', fontWeight: '600', color: 'text.dark' }}>You need a company email address</Text>
        <Text sx={{ fontSize: '16px', fontWeight: '400', color: 'text.main', textAlign: 'center' }}>
          To claim this profile, use an email that matches the company’s domain. If you think you should have access,{' '}
          <Box as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
            contact us
          </Box>
        </Text>
      </Flex>
    </Flex>
  </>
);

Mismatch.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};
